import axios from "axios";
import authHeader from "./auth-header";
import config from "../config";

export const getCompositions = () => {
  return axios.get(config.BASE_URL + "/billing", { headers: authHeader() });
};
